export type FormatMoneyFrOptions = {
  /** Append currency label (e.g. « 1 234,56 Dhs »). */
  suffix?: 'Dhs' | 'MAD';
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  /** When value is null/undefined — default formats as 0. */
  nullLabel?: string;
};

function parseMoneyValue(value: unknown): number | null {
  if (value == null || value === '') return null;
  const n = typeof value === 'number' ? value : Number(String(value).replace(',', '.'));
  return Number.isFinite(n) ? n : null;
}

/** French-grouped amount; optional Dhs/MAD suffix. */
export function formatMoneyFr(value: unknown, opts?: FormatMoneyFrOptions): string {
  const {
    suffix,
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    nullLabel,
  } = opts ?? {};

  const parsed = parseMoneyValue(value);
  if (parsed == null) {
    if (nullLabel != null) return nullLabel;
  }
  const safe = parsed ?? 0;
  const formatted = safe.toLocaleString('fr-FR', { minimumFractionDigits, maximumFractionDigits });
  return suffix ? `${formatted} ${suffix}` : formatted;
}
